import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import DeleteUgcForm from 'app/components/bibs/shared/ugc/DeleteUgcForm';
import ModalContainer from 'app/components/shared/Modal/ModalContainer';

export default function DeleteQuotationModal({
  quotationId,
  catalogBib,
  quotationsActions,
  handleSuccess,
  modalActions,
  quotationsTransactions
}) {
  function handleClose() {
    modalActions.closeModal(`delete-quotation-${quotationId}`);
  }

  return (
    <ModalContainer
      className="cp-delete-quotation-modal"
      modalKey={`delete-quotation-${quotationId}`}
      size="small"
      handleClose={handleClose}
    >
      <DeleteUgcForm
        ugcType="quotation"
        id={quotationId}
        catalogBib={catalogBib}
        removeUgcAction={quotationsActions.removeQuotation}
        transactions={quotationsTransactions}
        handleClose={handleClose}
        handleSuccess={handleSuccess}
      />
    </ModalContainer>
  );
}

DeleteQuotationModal.propTypes = {
  quotationId: PropTypes.number.isRequired,
  catalogBib: catalogBibShape.isRequired,
  handleSuccess: PropTypes.func,
  quotationsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  quotationsTransactions: ImmutablePropTypes.map.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};
